export default [
  { type: "black", alias: ["nero", "black"] },
  { type: "white", alias: ["bianco", "white"] },
  { type: "grey", alias: ["grigio", "grey"] },
  { type: "silver", alias: ["argento", "silver"] },
  { type: "blue", alias: ["blu", "blue"] },
  { type: "red", alias: ["rosso", "red"] },
  { type: "yellow", alias: ["giallo", "yellow"] },
  { type: "orange", alias: ["arancione", "orange"] },
  { type: "green", alias: ["verde", "green"] },
  { type: "other", alias: ["other", "altro"] }
];



// WEBPACK FOOTER //
// ./src/stores/vehicleInformationStore/data/colorTypes.js